import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';
import { activePractitionerDetails } from 'src/graphql';
import MainLayout from 'src/Components/Pages/MainLayout';
import ApiDocumentationPage from 'src/Components/Developer/ApiDocumentation/ApiDocumentationPage';

const ApiDocumentation = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const practitionerDetails = useReactiveVar(activePractitionerDetails);

    useEffect(() => {
        document.title = intl.formatMessage({
            id: 'LP_API_DOCUMENTATION_TITLE',
            defaultMessage: 'API Documentation',
        });
    }, [intl]);

    useEffect(() => {
        if (practitionerDetails !== null && practitionerDetails.isApiEnabled !== true) {
            navigate('/');
        }
    }, [practitionerDetails, navigate]);

    return (
        <MainLayout>
            <ApiDocumentationPage />
        </MainLayout>
    );
};

export default ApiDocumentation;
